<h1 matDialogTitle>
	{{
		(group?.value?.type === feedbackTypes.ACCOUNT_DELETION
			? 'feedback.deletion-title'
			: 'feedback.title'
		) | translate
	}}
</h1>
<app-loader
	[enableCircle]="true"
	[isActive]="this.isLoading$ | async"
	[width]="24"
></app-loader>
<mat-dialog-content cdkTrapFocus>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		action=""
		class="my-0"
	>
		<div tg-form-field>
			<label
				for="subject"
				tg-form-field-label
			></label>
			<div tg-container>
				<input
					[placeholder]="'feedback.subject' | translate"
					cdkInitialFocus
					formControlName="subject"
					id="subject"
					tg-input
					type="text"
				>
			</div>
		</div>
		<div tg-form-field>
			<label
				for="type"
				tg-form-field-label
			></label>
			<div tg-container>
				<mat-select
					class="px-2 py-2 tg-input tg-input-appearance-normal"
					formControlName="type"
					type="text"
				>
					<mat-option
						[value]="feedbackTypes[ftype.key]"
						*ngFor="let ftype of feedbackTypesArr"
					>
						{{ 'feedback-type.' + ftype.value | translate }}
					</mat-option>
				</mat-select>
			</div>
		</div>
		<div tg-form-field>
			<label
				for="name"
				tg-form-field-label
			></label>
			<div tg-container>
				<input
					[placeholder]="'feedback.name' | translate"
					formControlName="name"
					id="name"
					tg-input
					type="text"
				>
			</div>
		</div>
		<div tg-form-field>
			<label
				for="email"
				tg-form-field-label
			></label>
			<div tg-container>
				<input
					[placeholder]=" 'feedback.mail' | translate "
					formControlName="email"
					id="email"
					tg-input
					type="text"
				>
			</div>
		</div>
		<div tg-form-field>
			<label
				for="description"
				tg-form-field-label
			></label>
			<div tg-container>
				<textarea
					[placeholder]="
						(group?.value?.type === feedbackTypes.ACCOUNT_DELETION
							? 'feedback.deletion-description'
							: 'feedback.description'
						) | translate
					"
					formControlName="description"
					id="description"
					rows="5"
					tg-input
					type="text"
				></textarea>
			</div>
			<div
				*ngIf="this.group?.controls?.description?.errors?.minlength as descInputLength"
				class="text-right text-sm mat-hint mt-1"
			>
				{{ descInputLength.actualLength }}/ {{ descInputLength.requiredLength }}
			</div>
			<div
				*ngIf="group?.value?.type === feedbackTypes.ACCOUNT_DELETION"
				class="mat-hint mt-2"
			>
				{{ 'feedback.deletion-description-hint' | translate }}
			</div>
		</div>
		<div
			*ngIf="this.group?.value?.type === feedbackTypes.ACCOUNT_DELETION"
			class="tg-form-field"
		>
			<mat-checkbox
				class="deletion-newsletter-checkbox"
				color="primary"
				formControlName="newsletter_subscription"
			>
				{{ 'feedback.deletion-newsletter' | translate }}
			</mat-checkbox>
		</div>
	</form>
</mat-dialog-content>
<div class="border-t border-solid border-muted"></div>
<mat-dialog-actions class="!mb-2 !mt-2 !px-6">
	<button
		(click)="this.submit()"
		[disabled]="!this.group?.valid || (this.isLoading$ | async)"
		class="w-full !py-3 !rounded-lg"
		color="primary"
		mat-flat-button
	>
		{{ 'utils.submit' | translate }}
	</button>
</mat-dialog-actions>
